import { Paper } from "@mui/material";
import Grid from "@mui/material/Grid2";
import Subheading from "../../../components/common/Subheading";

/**
 * FormSection component
 *
 * Creates a styled section container for grouping related form elements.
 * Renders a Paper container with consistent elevation, padding, and styling
 * along with a section title.
 *
 * @param {Object} props - Component props
 * @param {string} props.title - Title text to display at the top of the section
 * @param {React.ReactNode} props.children - Content to render inside the section
 * @returns {JSX.Element} Styled form section with title and content
 */
const FormSection = ({ title, children }) => (
  <Paper elevation={2} sx={{ px: 3, borderRadius: 2, width: "100%", py: 4 }}>
    <Subheading text={title} sx={{ mb: 3, fontSize: "1.3rem" }} />
    <Grid container direction="column" spacing={3} width={"100%"}>
      {children}
    </Grid>
  </Paper>
);

export default FormSection;
